import React from "react";
import { FAQ } from "../../mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const Faq = () => {
  return (
    <section id="faq" className="py-28 border-t border-[#131c31] scroll-mt-24" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6">
        <p className="font-mono text-[10px] tracking-[0.35em] text-[#6f7d9f] uppercase mb-6 reveal">{FAQ.label}</p>
        <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-12 reveal" data-testid="faq-headline">
          {FAQ.headline}
        </h2>
        <Accordion type="single" collapsible className="reveal" data-testid="faq-accordion">
          {FAQ.items.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-[#1c2740]">
              <AccordionTrigger className="hover:no-underline py-6 group">
                <span className="flex items-center gap-6 text-left">
                  <span className="font-mono text-xs text-[#6b9be8]">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-heading uppercase text-white text-lg sm:text-xl tracking-tight group-hover:text-[#9db8e8] transition-colors">
                    {f.q}
                  </span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-[#8fa0c0] text-sm sm:text-base leading-relaxed pl-12 pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
